import React, { memo } from 'react';

export const MobileStub: React.FC = memo(() => (
  <svg width="80" height="64" viewBox="0 0 80 64" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20.252 8.63477H14.176V63.9998H20.252V8.63477Z" fill="#C4C4C4" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M15.3499 9.8124H19.078V62.8221H15.3499V9.8124ZM20.252 8.63477V63.9998H14.176V8.63477H20.252Z"
      fill="black"
    />
    <path d="M23.3909 8.63477H17.315L32.758 63.9998H38.834L23.3909 8.63477Z" fill="#C4C4C4" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.5004 9.8124L37.2865 62.8221H33.6486L18.8625 9.8124H22.5004ZM23.3909 8.63477L38.834 63.9998H32.758L17.315 8.63477H23.3909Z"
      fill="black"
    />
    <path
      d="M14.1758 4.36162C14.1758 1.95276 16.1224 0 18.5236 0H19.4482C21.8494 0 23.796 1.95276 23.796 4.36162V10.1587H14.1758V4.36162Z"
      fill="#F4BE55"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.4482 1.17764H18.5236C16.7707 1.17764 15.3497 2.60316 15.3497 4.36162V8.98108H22.6221V4.36162C22.6221 2.60316 21.2011 1.17764 19.4482 1.17764ZM18.5236 0C16.1224 0 14.1758 1.95276 14.1758 4.36162V10.1587H23.796V4.36162C23.796 1.95276 21.8494 0 19.4482 0H18.5236Z"
      fill="black"
    />
    <path d="M57.2148 8.63477H51.1389V63.9998H57.2148V8.63477Z" fill="#C4C4C4" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M52.3128 9.8124H56.0409V62.8221H52.3128V9.8124ZM57.2148 8.63477V63.9998H51.1389V8.63477H57.2148Z"
      fill="black"
    />
    <path d="M60.3538 8.63477H54.2779L69.7209 63.9998H75.7969L60.3538 8.63477Z" fill="#C4C4C4" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M59.4633 9.8124L74.2494 62.8221H70.6114L55.8254 9.8124H59.4633ZM60.3538 8.63477L75.7969 63.9998H69.7209L54.2779 8.63477H60.3538Z"
      fill="black"
    />
    <path
      d="M51.1387 4.36162C51.1387 1.95276 53.0853 0 55.4865 0H56.4111C58.8123 0 60.7589 1.95276 60.7589 4.36162V10.1587H51.1387V4.36162Z"
      fill="#F4BE55"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M56.4111 1.17764H55.4865C53.7336 1.17764 52.3126 2.60316 52.3126 4.36162V8.98108H59.585V4.36162C59.585 2.60316 58.164 1.17764 56.4111 1.17764ZM55.4865 0C53.0853 0 51.1387 1.95276 51.1387 4.36162V10.1587H60.7589V4.36162C60.7589 1.95276 58.8123 0 56.4111 0H55.4865Z"
      fill="black"
    />
    <g clipPath="url(#clip0_3596_306260)">
      <path d="M0 35.5557H89.1304V56.0553H0V35.5557Z" fill="#E6615E" />
      <path d="M0 35.5557H9.13043L17.8261 56.0553H8.69565L0 35.5557Z" fill="#F2F3F5" />
      <path d="M17.8261 35.5557H26.9565L35.6522 56.0553H26.5217L17.8261 35.5557Z" fill="#F2F3F5" />
      <path d="M35.6522 35.5557H44.7826L53.4783 56.0553H44.3478L35.6522 35.5557Z" fill="#F2F3F5" />
      <path d="M53.4783 35.5557H62.6087L71.3043 56.0553H62.1739L53.4783 35.5557Z" fill="#F2F3F5" />
      <path d="M71.3043 35.5557H80.4348L89.1304 56.0553H80L71.3043 35.5557Z" fill="#F2F3F5" />
    </g>
    <rect
      y="35.5566"
      width="80"
      height="15.2381"
      rx="0.627156"
      stroke="black"
      strokeWidth="3.38664"
      mask="url(#path-13-inside-1_3596_306260)"
    />
    <g clipPath="url(#clip1_3596_306260)">
      <path d="M0 12.6978H89.1304V33.1974H0V12.6978Z" fill="#E6615E" />
      <path d="M0 12.6978H9.13043L17.8261 33.1974H8.69565L0 12.6978Z" fill="#F2F3F5" />
      <path d="M17.8262 12.6978H26.9566L35.6523 33.1974H26.5218L17.8262 12.6978Z" fill="#F2F3F5" />
      <path d="M35.6523 12.6978H44.7828L53.4784 33.1974H44.348L35.6523 12.6978Z" fill="#F2F3F5" />
      <path d="M53.4785 12.6978H62.609L71.3046 33.1974H62.1742L53.4785 12.6978Z" fill="#F2F3F5" />
      <path d="M71.3047 12.6978H80.4351L89.1308 33.1974H80.0003L71.3047 12.6978Z" fill="#F2F3F5" />
    </g>
    <rect
      y="12.6992"
      width="80"
      height="15.2381"
      rx="0.627156"
      stroke="black"
      strokeWidth="3.38664"
      mask="url(#path-15-inside-2_3596_306260)"
    />
    <defs>
      <clipPath id="clip0_3596_306260">
        <rect y="35.5566" width="80" height="15.2381" rx="0.627156" fill="white" />
      </clipPath>
      <clipPath id="clip1_3596_306260">
        <rect y="12.6992" width="80" height="15.2381" rx="0.627156" fill="white" />
      </clipPath>
    </defs>
  </svg>
));
